<div class="center">
    <mat-card appearance="outlined" id = "style-4" class="cardcomponentMasks">
        <div class="arx-calendar">
            <iframe width="1500" height="800" src="https://calendar.google.com/calendar/embed?src=c_iqf0easvp8unk0q23fjmbfpt20%40group.calendar.google.com&amp;ctz=Europe%2FRome" frameborder="0" allowfullscreen="true"></iframe>
        </div>
    </mat-card>
</div>


